// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"breadcrumbs__Breadcrumbs__Y4d2P","breadcrumb":"breadcrumb__Breadcrumbs__Y4d2P"};